<template>
  <div id="discrepancy-loading" class="vs-con-loading__container">
    <vs-row>
      <vs-col vs-w="12">
        <vx-card :title="$t('discrepancies') | capitalize">
          <template slot="actions">
            <feather-icon
              @click="applyDatesFilter()"
              icon="FilterIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
            />

            <feather-icon
              icon="RefreshCwIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="resetFilters"
            />
          </template>
          <vs-row>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pr-1 mt-4">
              <datepicker
                placeholder="Start Date"
                :format="format"
                v-model="startDate"
              ></datepicker>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pl-1 mt-4">
              <datepicker
                placeholder="End Date"
                :format="format"
                v-model="endDate"
              ></datepicker>
            </vs-col>
          </vs-row>
        </vx-card>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="12" vs-lg="4" class="pr-1 mt-4">
        <vs-card maxHeight="40vh" class="custom-h"> 
          <div slot="header">
            <vs-row :style="{borderBottom:'#bec0c2 solid 2px'}">
              <vs-col>
                <h2 class="title-card-clickeable" @click="clickTitle('bar')">Southbound Discrepancies</h2>
                </vs-col>
            </vs-row>
          </div>
             <review-order-stacked-column chartId="barChart"
            :height="'380'" 
            @clickStackedSection="clickChart"
            > </review-order-stacked-column>
                   </vs-card>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="12" vs-lg="4" class="px-2 mt-4">
        <vs-card maxHeight="40vh" class="custom-h"> 
          <div slot="header">
            <vs-row :style="{borderBottom:'#bec0c2 solid 2px'}">
              <vs-col>
                <h2 class="title-card-clickeable" @click="clickTitle('donut')">Discrepancies by Supplier</h2>
                </vs-col>
            </vs-row>
          </div>
          <donut-chart
            :chartId="'donutChart'"
            :series="donutChart.series"
            :height="'400'"
            @clickDonutSection="clickChart"
          />
        </vs-card>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="12" vs-lg="4" class="pl-1 mt-4">
        <vs-card maxHeight="40vh" class="custom-h"> 
          <div slot="header">
            <vs-row :style="{borderBottom:'#bec0c2 solid 2px'}">
              <vs-col>
                <h2 class="title-card-clickeable" @click="clickTitle('treemap')">Discrepancies by Type</h2>
                </vs-col>
            </vs-row>
          </div>
          <treemap
            :title="'Types'"
            :chartId="'treemapChart'"
            :series="treemapChart.series"
            :colors="treemapChart.colors"
            :height="'400'"
            @clickSquare="clickChart"
          />
        </vs-card>
      </vs-col>
      <vs-col vs-2="12" class="mt-4">
        <vx-card>
          <discrepancy-table :data="list" @search="handleSearch" @sort="sort" @loadMore="loadMore"/>
        </vx-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import discrepancy from '@/http/requests/discrepancy'
import DiscrepancyTable from './components/DiscrepancyTable.vue'
import ReviewOrderStackedColumn from '@/views/modules/import_export/review_order/components/ReviewOrderStackedColumn'

import DonutChart from '@/views/apps/accounting/components/DonutChart.vue'
import Treemap from '@/views/Charts/TreemapChart.vue'
import moment from 'moment'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import Datepicker from 'vuejs-datepicker'
export default {
  components: {
    Datepicker,
    vSelect,
    DiscrepancyTable,
    DonutChart,
    ReviewOrderStackedColumn,
    Treemap,
  },
  computed: {
    isLoading() {
      return this.loading.data
    },
  },
  data() {
    return {
      params: {
        client: [],
        startDate: null,
        endDate: null,
      },
      lastPage: '',
      search: '',
      page: 1,
      startDate: moment().startOf('month').format('MM-DD-YYYY'),
      endDate: moment().format('MM-DD-YYYY'),
      format: 'MM/dd/yyyy',
      list: [],
      loading: {
        data: false,
      },
      select: [],
      clients: [],
      vendors: [],
      types: [],
      barChartData: {
        series: [],
        categories: [],
        colors: [],
      },
      donutChart: { series: [], labels: [], colors: [] },
      treemapChart: {
        series: [
          {
            data: [
              {
                x: 'Default',
                y: 0,
              },
            ],
          },
        ],
        colors: [
          '#3B93A5',
          '#F7B844',
          '#ADD8C7',
          '#EC3C65',
          '#CDD7B6',
          '#C1F666',
          '#D43F97',
          '#1E5D8C',
          '#421243',
          '#7F94B0',
          '#EF6537',
          '#C0ADDB',
        ],
      },
    }
  },
  methods: {
    getData() {
      this.formatDatesToDB()
      this.loading.data = true
      const data = Object.assign({}, this.params)
      data.page = this.page
      data.search = this.search
      //data.startDate = this.params.startDate
      //data.endDate = this.params.endDate
      discrepancy
        .getList(data)
        .then((res) => {
          this.lastPage = res.data.last_page
          if (data.page > 1) {
            this.list.push(...res.data.data)
          } else {
            this.list = [...res.data.data]
          }
          this.loading.data = false
        })
        .catch((err) => {
          this.loading.data = false
        })
    },

    loadMore() {
      if (this.page >= this.lastPage) {
        return
      }
      this.page++
      this.getData()
    },

    handleSearch(text) {
      this.search = text
      this.page = 1
      this.getData()
    },

    sort(e) {
      this.params.sortBy = e.sortBy
      this.params.sort = e.sort
      this.getData()
    },

    getDiscrepanciesByClient() {
      discrepancy
        .getDiscrepanciesByClient(this.params)
        .then((res) => {
          let clients = res.data.items
          let colors = clients.map(({ color }) => color)
          let categories = []
          let series = []
          this.clients = clients.map((item) => ({
            name: item.ShortName,
            id: item.ClientId,
          }))
          let index_code = 0
          let index_name = 0
          let names = []
          clients.forEach((item, index) => {
            if (categories.indexOf(item.ShortName) === -1) {
              categories[categories.length] = item.ShortName
            }
            if (names.indexOf(item.ShortName) === -1) {
              names[names.length] = item.ShortName
              index_name = names.length - 1
              series[index_name] = {
                name: item.ShortName,
                data: [],
              }
            }
            index_code = categories.indexOf(item.ShortName)
            index_name = names.indexOf(item.ShortName)
            series[index_name].data[index_code] = Number(item.total)
          })
          /* let series = clients.map((item) =>({
            name:item.ShortName,
            data:[parseInt(item.total)]
          })) */
          this.barChartData = Object.assign({}, this.barChartData, {
            series,
            categories,
            colors,
          })
          ApexCharts.exec(
            'barChart',
            'updateOptions',
            {
              series: this.barChartData.series,
              colors: colors,
              xaxis: {
                categories: categories,
              },
            },
            false,
            true
          )
        })
        .catch((err) => {
          console.log(err)
        })
    },

    getDiscrepanciesByVendor() {
      discrepancy
        .getDiscrepanciesByVendor(this.params)
        .then((res) => {
          let vendors = res.data.items
          this.donutChart.labels = vendors.map(({ VendorName }) => VendorName)

          this.vendors = vendors.map((item) => ({
            id: item.VendorId,
            name: item.VendorName,
          }))

          this.donutChart.series = vendors.map(({ total }) => parseInt(total))
          this.fillDonut()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDiscrepanciesByType() {
      discrepancy
        .getDiscrepanciesByType(this.params)
        .then((res) => {
          let types = res.data.items
          let seriesData = types.map((item) => ({
            x: item.type.charAt(0).toUpperCase() + item.type.slice(1),
            y: item.total,
          }))

          this.types = types.map((item) => ({
            id: item.discrepancy_id,
            name: item.type.charAt(0).toUpperCase() + item.type.slice(1), // (item.type)|capitalize
          }))

          let series = [
            {
              data: seriesData,
            },
          ]
          this.treemapChart.series = series
        })
        .catch((err) => {
          console.log(err)
        })
    },
    fillDonut() {
      let colors = [
        '#3B93A5',
        '#F7B844',
        '#ADD8C7',
        '#EC3C65',
        '#CDD7B6',
        '#C1F666',
        '#D43F97',
        '#1E5D8C',
        '#421243',
        '#7F94B0',
        '#EF6537',
        '#C0ADDB',
      ]
      ApexCharts.exec(
        'donutChart',
        'updateOptions',
        {
          fill: {
            colors: colors,
          },
          legend: {
            markers: {
              fillColors: colors,
            },
          },
          labels: this.donutChart.labels,
          tooltip: {
            fillSeriesColor: false,
          },
        },
        false,
        true
      )
    },
    clickChart(config) {
      let selected = []
      if (config.w.config.chart.id == 'barChart') {
        selected = this.clients.filter((item) => {
          return (
            item.name == config.w.config.xaxis.categories[config.seriesIndex]
          )
        })
        this.params.type = []
        this.params.vendor = []
        this.params.client = [selected[0].id]
        this.loadEveryChart()
      } else if (config.w.config.chart.id == 'donutChart') {
        selected = this.vendors.filter((item) => {
          return item.name == config.w.config.labels[config.dataPointIndex]
        })
        this.params.type = []
        this.params.client = []
        this.params.vendor = [selected[0].id]
        this.loadEveryChart()
      } else if (config.w.config.chart.id == 'treemapChart') {
        console.log(config.w.config.series[0].data[config.dataPointIndex].x)
        selected = this.types.filter((item) => {
          return (
            item.name == config.w.config.series[0].data[config.dataPointIndex].x
          )
        })
        this.params.client = []
        this.params.vendor = []
        this.params.type = [selected[0].id]
        this.loadEveryChart()
      }

      this.page = 1
      this.getData()
    },
    resetFilters() {
      this.startDate = moment().startOf('month').format('MM-DD-YYYY')
      this.endDate = moment().format('MM-DD-YYYY')
      this.clickTitle()
    },
    clickTitle(clicked_element) {
      this.params.client = []
      this.params.vendor = []
      this.params.type = []
      this.page = 1
      this.search = ''
      this.getData()
      this.loadEveryChart()
    },
    loadEveryChart() {
      this.getDiscrepanciesByClient()
      this.getDiscrepanciesByVendor()
      this.getDiscrepanciesByType()
    },
    applyDatesFilter() {
      this.getData()
      this.loadEveryChart()
    },
    formatDatesToDB() {
      this.params.startDate = moment(this.startDate).format('YYYY-MM-DD')
      this.params.endDate = moment(this.endDate).format('YYYY-MM-DD')
    },
  },
  mounted() {
    this.getData()
    this.loadEveryChart()
  },
  mixins: [loading],
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('discrepancy-loading')
      } else {
        this.closeLoading('discrepancy-loading')
      }
    },
  },
}
</script>

<style>
.title-card-clickeable {
  cursor: pointer;
  padding: 10px;
}

.custom-h {
  height: 500px;
}
</style>
